import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';
import en from '@angular/common/locales/en';
import es from '@angular/common/locales/es';
import fr from '@angular/common/locales/fr';
import nl from '@angular/common/locales/nl';

registerLocaleData(en);
registerLocaleData(fr);
registerLocaleData(de);
registerLocaleData(nl);
registerLocaleData(es);

export const getSupportedLocale = (locale: string) => {
  switch (locale.substring(0, 2))
  {
    case 'en': 
    case 'fr': 
    case 'de': 
    case 'nl': 
    case 'es':
      return locale;
    default:
      return 'en';
  }
}